import React, { forwardRef, useMemo, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import styled from 'styled-components';
import { FieldContainer } from './FieldContainer';
import FunPlaceholder from './FunPlaceholder';

const getRandomId = () => uuid();

interface TextFieldProps {
  error?: boolean | string;
  label?: string;
  onBlur?: (currentValue: string) => void;
  onChange?: (value: string) => void;
  placeholder?: string;
  funPlaceholder?: boolean;
  value: string;
  name: string;
  type?: string;
  maxLength?: number;
}

const Input = styled.input.withConfig({ componentId: 'sc-r0yb45-0' })`
  height: 58px;
  border-radius: unset;
  font-size: 18px;

  box-sizing: border-box;
  display: inline-block;
  text-decoration: none;
  outline: 0;
  // position: relative;
  overflow: hidden;
  // bottom: 0;
  color: #313131;
  // left: 0;
  line-height: 24px;
  width: 100%;
  background: 0 0;
  border: none;

  font-family: Circular-Pro-Book-S, Roboto, sans-serif;

  padding: 24px 10px 10px 20px;
`;

const TextField = forwardRef(function TextField(
  {
    error,
    label,
    onBlur,
    onChange,
    placeholder,
    funPlaceholder = true,
    value,
    name,
    type,
    maxLength,
  }: TextFieldProps,
  ref: React.Ref<HTMLInputElement>
) {
  const id = useMemo(getRandomId, []);
  const [isFieldActive, setIsFieldActive] = useState<boolean>(false);

  const handleOnBlur = (e: any) => {
    onBlur?.(e.target.value);
    setIsFieldActive(false);
  };

  const handleOnFocus = (e: any) => {
    setIsFieldActive(true);
  };

  const inputRef = useRef<HTMLDivElement>(null);

  const focusInput = () => {
    inputRef?.current?.querySelector('input')?.focus();
  };

  return (
    <FieldContainer error={!!error}>
      <div onClick={focusInput}>
        {!!label && !funPlaceholder && <label htmlFor={id}>{label}</label>}
        <div ref={inputRef}>
          {funPlaceholder && !!placeholder && (
            <FunPlaceholder
              error={!!error}
              shrink={isFieldActive || !!value?.length}
              text={placeholder}
            />
          )}
          <Input
            id={id}
            maxLength={maxLength}
            name={name}
            onBlur={handleOnBlur}
            onChange={(e) => onChange?.(e.target.value)}
            onFocus={handleOnFocus}
            ref={ref}
            type={type}
            value={value}
          />
        </div>
      </div>
    </FieldContainer>
  );
});

export default TextField;
